module.exports = __webpack_public_path__ + "img/item_bookCover_09.c3bad050.jpeg";